/*
 * @Descripttion: 项目结算管理
 * @Date: 2025-05-23 13:32:18
 */
import { XrkTableProps } from 'xrk-components';

import {
  userNameSearch,
  phoneSearch,
  userTagSearch,
  individualNameSearch,
  projectStatusSearch,
  cancelStatusSearch,
  parkNameSearch,
  userTypeSearch
} from '../fields/searchs';
import {
  indexCol,
  servicePersonCol,
  phoneCol,
  userTagCol,
  occupationAuthStatusCol,
  realNameStatusCol,
  payPassagewayNameCol,
  checkStatusCol,
  contractStatusCol,
  inStatusCol,
  projectStatusCol,
  isSettlementCol,
  cancelStatusCol,
  prePurchaseAtCol,
  prePurchaseNumCol,
  industryNumCol,
  toBeAuditTaskSumCol,
  passingNumCol,
  passNumCol,
  noPassNumCol,
  noFinishNumCol,
  taskProgressCol,
  taskSumNoFinishPriceCol,
  taskSumPassedCsoPriceCol,
  monthSettlementPriceCol,
  servicePriceCol,
  appSettlementPriceCol,
  invalidTaskNumCol,
  individualNameCol,
  parkNameCol,
  userTypeCol,
  projectPriceCol,
  cPriceCol
} from '../fields/columns';
import { computed, ComputedRef, Ref } from 'vue';
import { getProjectInfo } from '../data-source/apis';
import { PAY_PASSAGEWAY_MAPPING } from '@/common/constants/bank/index';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';

export const createTable = async (
  isGeti: ComputedRef<boolean>,
  projectId: number,
  isSupplier: Ref<boolean>,
  isAsp: Ref<boolean>,
  projectType: number,
  whetherIndustrialData: { sceneType: number; whetherIndustrial: 0 | 1 }
) => {
  const { data: projectInfoData } = await getProjectInfo({
    projectId
  });

  const store = useProjectDetailStore();
  const taxPattern = computed(() => store.baseData.txnStructInfo.taxPattern);
  const { participantType } = projectInfoData;

  const contractStatusColShow = computed(() => {
    if (isAsp.value) {
      //基地、代开、代发、个体
      return [4, 6, 3, 5].includes(taxPattern.value);
    }
    if (isSupplier.value) {
      //代发、汇总 //供应商也不展示此字段了 -XRK-2-9434
      return false;
    }
    return false;
  });
  const is19ProjectType = projectType === 19;

  let searchColumns: XrkTableProps['searchConfig']['searchColumns'] = [];
  let tableColumns: XrkTableProps['tableConfig']['tableColumns'] = [];

  searchColumns = [
    {
      ...userNameSearch,
      prop: 'fullName',
      label: isGeti.value ? '经营者' : '终端服务人员'
    },
    phoneSearch,
    isGeti.value && { ...individualNameSearch, prop: 'personName' },
    isGeti.value && parkNameSearch,
    userTagSearch,
    userTypeSearch,
    projectStatusSearch,
    cancelStatusSearch
  ].filter(Boolean);
  tableColumns = [
    indexCol,
    {
      ...servicePersonCol,
      prop: 'fullName',
      label: isGeti.value ? '经营者' : '终端服务人员'
    },
    isGeti.value && { ...individualNameCol, prop: 'personName' },
    isGeti.value && parkNameCol,
    phoneCol,
    userTagCol,
    userTypeCol,
    occupationAuthStatusCol,
    realNameStatusCol,
    {
      ...payPassagewayNameCol,
      renderHeader() {
        return (
          <div>
            <div>支付通道</div>
            <div>
              {`（${
                PAY_PASSAGEWAY_MAPPING?.[projectInfoData.payPassagewayCode]
                  ?.label
              }）` || ''}
            </div>
          </div>
        );
      }
    },
    checkStatusCol,
    contractStatusColShow.value && contractStatusCol,
    inStatusCol,
    projectStatusCol,
    isSettlementCol,
    cancelStatusCol,
    prePurchaseAtCol,
    !isSupplier.value && !is19ProjectType && prePurchaseNumCol,
    !isSupplier.value && industryNumCol,
    toBeAuditTaskSumCol,
    passingNumCol,
    passNumCol,
    noPassNumCol,
    !is19ProjectType && noFinishNumCol,
    !isSupplier.value && !is19ProjectType && taskProgressCol,
    [1, 4, 7].includes(participantType) &&
      !isSupplier.value &&
      !is19ProjectType &&
      taskSumNoFinishPriceCol, // 工业-asp-p-c/工业-asp-c /工业-运营基地-c显示
    [1, 4, 7].includes(participantType) &&
      !isSupplier.value &&
      taskSumPassedCsoPriceCol, // 工业-asp-p-c/工业-asp-c /工业-运营基地-c显示
    monthSettlementPriceCol,
    [1, 2].includes(participantType) && servicePriceCol, //工业-asp-p-c、工业-p-c 显示
    [1, 2, 4, 5, 7].includes(participantType) && appSettlementPriceCol, //工业-asp-p-c、工业-asp-c、工业-p-c、工业-c /工业-运营基地-c显示
    invalidTaskNumCol,

    // 任务汇总增加两个字段【列表】【导出】有工业的增加项目结算单价（不含税）（工业-服务商），无工业的只有终端结算单价（工业-c）,首先排除协定服务。
    ...(whetherIndustrialData.sceneType !== 19
      ? [
          !whetherIndustrialData.whetherIndustrial && projectPriceCol,
          cPriceCol
        ].filter(Boolean)
      : [])
  ].filter(Boolean);
  return {
    searchColumns,
    tableColumns: tableColumns.map((item: any, index) => {
      if (item.type !== 'index') {
        item = {
          ...item,
          _sign: 'base',
          _sort: index + 1,
          _checked: 1,
          _disabled: ['终端服务人员', '手机号', '个体名称'].includes(item.label)
        };
      }
      return item;
    })
  };
};
